/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleToolbarAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ToggleToolbarAction({
  children,
  viewPath = "/DesignSystem/ImageViewer/ToggleToolbarAction"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnToggleToolbar({
  children,
  viewPath
  
})
let viewerIsToolbarHiddenValueData = fromData.useDataValue({ viewPath,
context: 'viewer',
path: 'is_toolbar_hidden',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 marginLeft={dtSpaceXxs}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={viewerIsToolbarHiddenValueData ? "Show toolbar" : "Hide toolbar"}
 data="viewer.is_toolbar_hidden"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}